<grid-virtual-scroll-viewport class="main-grid">
  <ng-container *gridVirtualFor="let rows of activityListDataSource; itemMinWidth: minWidth; itemMaxWidth: maxWidth; minGap: minGap;">
    @for (item of rows; track item) {
      <li class="columns">
        <ngx-activity-card [activity]="item"></ngx-activity-card>
      </li>
    }
  </ng-container>
</grid-virtual-scroll-viewport>
